import { useState } from 'react'
import TeamData from '../../data/TeamData'
import Team from '../Team/Team'
import Score from '../Score/Score'
import './Match.css'
import MatchDate from '../MatchDate/MatchDate'
import DetailsButton from '../DetailsButton/DetailsButton'
import MatchDetailsContainer from '../MatchDetailsContainer/MatchDetailsContainer'
import PlayerDetailsContainer from '../PlayerDetailsContainer/PlayerDetailsContainer'
import { Collapse } from '@material-ui/core'

const Match = ({ match }) => {
  const LOCAL_STORAGE_KEY = `detailsShowing${match.match_id}`
  const detailsPanels = {
    STATS: 'stats',
    HOME: 'home',
    AWAY: 'away'
  }

  const homeTeam = TeamData.filter(
    (team) => team.team_id === match.match_home_team_id
  )[0]
  const awayTeam = TeamData.filter(
    (team) => team.team_id === match.match_away_team_id
  )[0]

  const [detailsShowing, setDetailsShowing] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY)
  )

  const toggleDetails = (setting) => {
    const newSetting = detailsShowing === setting ? '' : setting
    setDetailsShowing(newSetting)
    localStorage.setItem(LOCAL_STORAGE_KEY, newSetting)
  }

  return (
    <div className="outerMatchContainer">
      <div className="matchContainer">
        {homeTeam && awayTeam && (
          <>
            <div className="innerMatchContainer">
              <MatchDate date={match.match_date} />
              <div className="teamsScoreAndStats">
                <div className="teamsAndScore">
                  <Team
                    team={homeTeam}
                    match={match}
                    detailsShowing={detailsShowing === detailsPanels.HOME}
                    onClick={() => {
                      toggleDetails(detailsPanels.HOME)
                    }}
                  />
                  <Score match={match} />
                  <Team
                    team={awayTeam}
                    match={match}
                    detailsShowing={detailsShowing === detailsPanels.AWAY}
                    onClick={() => {
                      toggleDetails(detailsPanels.AWAY)
                    }}
                  />
                </div>
                <DetailsButton
                  detailsShowing={detailsShowing === detailsPanels.STATS}
                  onClick={() => {
                    toggleDetails(detailsPanels.STATS)
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <Collapse in={detailsShowing}>
        {detailsShowing === detailsPanels.STATS && (
          <div className="detailsPanelContainer">
            <MatchDetailsContainer
              match={match}
              homeTeam={homeTeam}
              awayTeam={awayTeam}
            />
          </div>
        )}
        {(detailsShowing === detailsPanels.HOME ||
          detailsShowing === detailsPanels.AWAY) && (
          <PlayerDetailsContainer
            team={detailsShowing === detailsPanels.HOME ? homeTeam : awayTeam}
            match={match}
          />
        )}
      </Collapse>
    </div>
  )
}

export default Match
